<template>
  <div class="analyzing-screen">
    <div class="analyzing-screen__spinner" aria-hidden="true" />
    <h2>응답 결과를 분석하고 있습니다.</h2>
    <p>잠시만 기다려 주세요.</p>
  </div>
</template>
